import React from "react";

export const PrivacyText = (props) => {
  return (
    <div id="privacy" className="text-center">
      <div className="containerInfo">
        <div className="section-title">
          <article className="arti">
            <h1 className="headerInfo">Privacy Policy</h1>
            <p>
              ColorYou developers built the ColorYou app as a Freemium app. This
              SERVICE is provided by ColorYou at no cost and is intended for use
              as is.
            </p>
            <p>
              This page is used to inform visitors regarding the policies with
              the collection, use, and disclosure of Personal Information if
              anyone decided to use the Service.
            </p>
            <p>
              If you choose to use the Service, then you agree to the collection
              and use of information in relation to this policy. The Personal
              Information that we collect is used for providing and improving
              the Service. We will NOT use or share your information with anyone
              except as described in this Privacy Policy.
            </p>
            <p>
              The terms used in this Privacy Policy have the same meanings as in
              our Terms and Conditions, which are accessible at ColorYou unless
              otherwise defined in this Privacy Policy.
            </p>
            <br />
            <p>
              <strong>
                Information Collection and Use (Photos &amp; Face Data)
              </strong>
            </p>
            <div>
              <p>
                ColorYou lets you take or select a photo to enable virtual
                try-on and color analysis. To place makeup/hair overlays and
                compute your seasonal palette, the app transmits your photo{" "}
                <strong>over HTTPS</strong> to our backend, where it is
                processed <strong>transiently in memory</strong> to derive
                <em>facial landmarks</em> (e.g., eyes, lips, face contour),
                simple <em>segmentation masks</em>, and
                <em>color values</em> (skin, hair, eyes). The image and the
                derived face data are <strong>not stored</strong> on our servers
                and are discarded immediately after processing.
              </p>

              <p>
                We <strong>do not</strong> create or collect biometric
                identifiers, face embeddings/templates, perform face recognition
                or identity matching, or access TrueDepth/Face ID depth maps.
              </p>

              <p>
                <strong>How We Use Face Data</strong>
              </p>
              <p>
                Solely to: (i) render virtual try-on (makeup, hair colors and
                hairstyles); (ii) analyze your seasonal color palette and
                related recommendations; and (iii) preview garment
                colors/patterns and styling combinations on your photo. We do{" "}
                <strong>not</strong> use face data for advertising, tracking,
                authentication, identity matching, or model training.
              </p>

              <p>
                <strong>Sharing and Disclosure</strong>
              </p>
              <p>
                We <strong>do not share</strong> your photos or face data with
                third parties. Services used for in-app purchases (e.g.,
                RevenueCat) receive purchase/receipt metadata only —{" "}
                <strong>no</strong> images or face data.
              </p>

              <p>
                <strong>Retention &amp; Deletion</strong>
              </p>
              <p>
                For convenience, your selected photo may be saved{" "}
                <strong>locally on your device</strong> so you don’t need to
                re-upload it. You can delete all locally stored data at any time
                in <em>Settings → Delete all your data</em>, or by uninstalling
                the app. Server-side processing is ephemeral; we{" "}
                <strong>do not retain</strong> images or face data after
                responding.
              </p>

              <p>
                <strong>Other Data</strong>
              </p>
              <p>
                We may determine your language and infer your country to show
                localized content. This information is used in-app and is not
                combined with face data.
              </p>

              <p>
                <strong>Third-Party Services</strong>
              </p>
              <p>
                Links to the privacy policies of third-party service providers
                used by the app:
              </p>
              <ul>
                <li>
                  <a
                    href="https://www.google.com/policies/privacy/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Google Play Services
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.revenuecat.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    RevenueCat
                  </a>
                </li>
              </ul>
            </div>

            <p>
              <strong>Log Data</strong>
            </p>
            <p>
              We want to inform you that whenever you use my Service, in a case
              of an error in the app we may collect data and information
              (through third-party products) on your phone called Log Data. This
              Log Data may include information such as your device Internet
              Protocol (“IP”) address, device name, operating system version,
              the configuration of the app when utilizing the Service, the time
              and date of your use of the Service, and other statistics.
            </p>
            <p>
              <strong>Cookies</strong>
            </p>
            <p>
              Cookies are files with a small amount of data that are commonly
              used as anonymous unique identifiers. These are sent to your
              browser from the websites that you visit and are stored on your
              device's internal memory.
            </p>
            <p>
              This Service does NOT use these “cookies” explicitly. However, the
              app may use third-party code and libraries that use “cookies” to
              collect information and improve their services. You have the
              option to either accept or refuse these cookies and know when a
              cookie is being sent to your device. If you choose to refuse our
              cookies, you may not be able to use some portions of this Service.
            </p>
            <p>
              <strong>Service Providers</strong>
            </p>
            <p>
              We may employ third-party companies and individuals due to the
              following reasons:
            </p>
            <ul>
              <li>To facilitate our Service;</li>
              <li>To provide the Service on our behalf;</li>
              <li>To perform Service-related services; or</li>
              <li>To assist us in analyzing how our Service is used.</li>
            </ul>
            <p>
              We want to inform users of this Service that these third parties
              have access to their Personal Information. The reason is to
              perform the tasks assigned to them on our behalf. However, they
              are obligated not to disclose or use the information for any other
              purpose.
            </p>
            <p>
              <strong>Security</strong>
            </p>
            <p>
              We value your trust in providing us your Personal Information,
              thus we are striving to use commercially acceptable means of
              protecting it. But remember that no method of transmission over
              the internet, or method of electronic storage is 100% secure and
              reliable, and we cannot guarantee its absolute security.
            </p>
            <p>
              <strong>Links to Other Sites</strong>
            </p>
            <p>
              This Service may contain links to other sites. If you click on a
              third-party link, you will be directed to that site. Note that
              these external sites are not operated by us. Therefore, we
              strongly advise you to review the Privacy Policy of these
              websites. We have no control over and assume no responsibility for
              the content, privacy policies, or practices of any third-party
              sites or services.
            </p>
            <p>
              <strong>Children’s Privacy</strong>
            </p>
            <div>
              <p>
                These Services do not address anyone under the age of 13. We do
                not knowingly collect personally identifiable information from
                children under 13 years of age. In the case we discover that a
                child under 13 has provided us with personal information, we
                immediately delete this from our servers. If you are a parent or
                guardian and you are aware that your child has provided us with
                personal information, please contact me so that I will be able
                to do the necessary actions.
              </p>
              <p>
                <strong>Changes to This Privacy Policy</strong>
              </p>
              <p>
                We may update our Privacy Policy from time to time. Thus, you
                are advised to review this page periodically for any changes. We
                will notify you of any changes by posting the new Privacy Policy
                on this page.
              </p>
              <p>This policy is effective as of 2024-03-01</p>
              <p>
                <strong>Contact Us</strong>
              </p>
              <p>
                If you have any questions or suggestions about our Privacy
                Policy, do not hesitate to contact us at{" "}
                <span style={{ color: "#DD3D99" }}> coloryouapp@gmail.com</span>
                .
              </p>
            </div>
          </article>
        </div>
      </div>
    </div>
  );
};
